import { createFileRoute } from "@tanstack/react-router";
import { cityServiceHead } from "../lib/route-head";
import { CityServicePage } from "../components/city-service-page";
import { getCityService } from "../data/city-services";


export const Route = createFileRoute("/roof-moss-removal-colonie-ny")({
  loader: async () => {
    const c = (await import("../data/city-services")).getCityService("roof-moss-removal-colonie-ny")!;
    return { meta: c.meta, heroImage: c.heroImage, service: c.service, city: c.city, faqs: c.faqs };
  },
  head: ({ loaderData }) => cityServiceHead("roof-moss-removal-colonie-ny", "roof-moss-removal", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  return <CityServicePage content={getCityService("roof-moss-removal-colonie-ny")!} />;
}
